import * as z from 'zod';

import { statusQuerySchema } from '@/_schemas/status-input';

import { environmentQuerySchema } from './environment-schema';

export const aPIKeyQueryLinkerSchema = z.object({
  id: z.number(),
  api_integration_id: z.number(),
  api_key: z.string().min(2),
  environment: environmentQuerySchema,
  status: statusQuerySchema.nullable(),
  created_by_id: z.number(),
  last_updated_by_id: z.number(),

  expiration_date: z.string().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export type APIKeyQueryLinkerSchema = z.infer<typeof aPIKeyQueryLinkerSchema>;
